export const generateRazorPayAPIKeySteps = [
  'Log into your RazorpayX Payroll account.',
  'Navigate to the RazorpayX Payroll Integrations tab.',
  'Select the SpringVerify option.',
  'Click on the "Generate Now" button to generate the API key.'
];

export const leverSSOAuthentication = [
  'Click on Connect.',
  'Sign-in to Lever with your user credentials (Lever SuperAdmin Only) and provide the required permissions.'
];
export const leverConfiguration = [
  ' Select the stage from Lever that will push a candidate to SpringVerify for a background check.',
  'Map the relevant tags from Lever to the package variations on SpringVerify.'
];
export const greenHouseAPIAuthentication = [
  'Generate an API key on Greenhouse with the required permissions'
];
export const greenHouseWebHookDetails = [
  'Name: SpringVerify BGV',
  `When: "Candidate has been hired" OR "Offer approved"`
];

export const knowledgeBase = {
  Lever:
    'https://support.springworks.in/portal/en/kb/articles/integration-of-lever-with-springverify',
  Greenhouse:
    'https://support.springworks.in/portal/en/kb/articles/integration-of-greenhouse-with-springverify',
  RazorpayX:
    'https://support.springworks.in/portal/en/kb/articles/integration-of-razorpayx-with-springverify',
  default:
    'https://support.springworks.in/portal/en/kb/springverify-india/client-knowledge-base/integrations'
};
export const integrationUrl = {
  Lever: 'https://www.lever.co/',
  Greenhouse: 'https://www.greenhouse.com/',
  Recruitee: 'https://recruitee.com/',
  'Zoho Recruit': 'https://www.zoho.com/recruit'
};
export const integrationText = {
  Lever: 'www.lever.co',
  Greenhouse: 'www.greenhouse.com',
  Recruitee: 'www.recruitee.com',
  'Zoho Recruit': 'https://www.zoho.com/recruit'
};
export const generateRecruiteeAPIKeySteps = [
  'Log into your Recruitee account',
  'Navigate to the Recruitee integrations tab',
  'select SpringVerify',
  'Click on "Generate Now" button to generate the APi key'
];

export const recruiteeSourceName = ['RECRUITEE'];
